import React from "react";

type Props = {
    email: string;
    email_error?: string;
    setValue: (name: string, value: string | boolean) => void;
};

export const InputEmail = ({ email, email_error, setValue }: Props) => {
    return (
        <div className="form-flex">
            <div className="form-flex-txt">メールアドレス</div>
            <div className="form-flex-input">
                <input type="email" name="email" placeholder="メールアドレス" required
                    className={email_error ? 'form-input-error' : ''}
                    value={email}
                    onChange={(e) => setValue('email', e.target.value)}
                />
                {email_error && <span className="form-error-message">{email_error}</span>}
            </div>
        </div>
    );
};
